// Lib
import { createAction } from '@reduxjs/toolkit';

export const SetFilters = createAction('SET_FILTERS');
export const ChangeFilter = createAction('CHANGE_FILTER');
export const ClearFilters = createAction('CLEAR_FILTERS');
export const SaveFilters = createAction('SAVE_FILTERS');
